export default __webpack_public_path__ + "67214b0b011de3e4616c2c834989a8e4.svg";